module.exports = __webpack_public_path__ + "img/data-center-bg.6a34cd8a.jpg";